const CommonEndPoints = {
    uploadMedia: (mediaFor, mediaType) => ({
        url: `/media-upload/${mediaFor}/${mediaType}`,
        method: "POST",
    })
}

export default CommonEndPoints;